import { render, staticRenderFns } from "./gamelist.vue?vue&type=template&id=06180df6&scoped=true"
import script from "./gamelist.vue?vue&type=script&lang=js"
export * from "./gamelist.vue?vue&type=script&lang=js"
import style0 from "./gamelist.vue?vue&type=style&index=0&id=06180df6&prod&lang=scss&scoped=true"
import style1 from "./gamelist.vue?vue&type=style&index=1&id=06180df6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06180df6",
  null
  
)

export default component.exports